import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'nsips-relation-situations-list',
  data: function () {
    var today = new Date
    return {
      shopId: null,
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      patientName: null,
      clinicName: null,
      doctorName: null,
      clinicId: null,
      searchCallbackFlag: false,
      watchScroll: null,
      // 確認ダイアログ用
      confirmTitle: '',
      confirmMessage: '',
      confirmOnYes: () => {},
      confirmOnNo: () => {},
      unregisterFlag: false
    }
  },
  beforeRouteLeave (to, from, next) {
    // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#doctor_name_autocomplete'})
    // 最下部スクロールイベント削除
    utils.scrollBottomSearchEventRemove()
    next()
  },
  created: function () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    // 検索条件が保存されていたら表示
    var ssPatientName = window.sessionStorage.getItem("nrsl-patientName")
    var ssClinicName = window.sessionStorage.getItem("nrsl-clinicName")
    var ssDoctorName = window.sessionStorage.getItem("nrsl-doctorName")
    var ssYear = window.sessionStorage.getItem("nrsl-year")
    var ssMonth = window.sessionStorage.getItem("nrsl-month")
    this.patientName = ssPatientName
    this.clinicName = ssClinicName
    this.doctorName = ssDoctorName
    if (!!ssYear) {
      this.year = ssYear
    }
    if (!!ssMonth) {
      this.month = ssMonth
    }
    this.search(false)
    utils.autocompleteEvent({$: $, elem: '#clinic_name_autocomplete', search: this.search, searchParams: false, searchAutocomplete: this.getClinics, setSearchData: this.setSearchClinic, clear: this.clearClinics });
    utils.autocompleteEvent({$: $, elem: '#doctor_name_autocomplete', search: this.search, searchParams: false, searchAutocomplete: this.getDoctors, setSearchData: this.setSearchDoctor, clear: this.clearDoctors });
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    years () {
      var today = new Date
      var years = []
      for (var y = 2015; y <= today.getFullYear(); y++ ) {
        years.push({'id': y, 'text': y + this.$t('ymd.year')})
      }
      return years
    },
    months () {
      var months = []
      for (var m = 1; m <= 12; m++ ) {
        months.push({'id': m, 'text': m + this.$t('ymd.month')});
      }
      return months
    },
    prescriptions () {
      return this.$store.getters.patient_relation_situations
    },
    clinics () {
      return this.$store.getters.ns_clinics
    },
    doctors () {
      return this.$store.getters.ns_doctors
    },
    /** 通知 */
    notify() {
      return this.$store.getters.Notify
    },
    /** ページ送り **/
    nextPage () {
      return this.$store.getters.patient_relation_situations_next_page
    },
    currentPage () {
      return this.$store.getters.patient_relation_situations_current_page
    }
  },
  methods: {
    search: function (readMore) {
      var self = this
      var url = null
      if (readMore) {
        url = this.nextPage
      } else {
        this.searchCallbackFlag = false
      }
      var data = {
        'shop_id': this.shopId,
        'patient_name': this.patientName,
        'clinic_name': this.clinicName,
        'doctor_name': this.doctorName,
        'year': this.year,
        'month': this.month,
        'unregister': this.unregisterFlag
      }
      var callback = function () {
        self.searchCallbackFlag = true
      }
      // 検索履歴保持
      if (this.patientName !== "" && !!this.patientName) {
        window.sessionStorage.setItem("nrsl-patientName", this.patientName)
        console.log(this.patientName)
      } else {
        window.sessionStorage.removeItem("nrsl-patientName")
        console.log("remove")
      }
      if (this.clinicName !== "" && !!this.clinicName) {
        window.sessionStorage.setItem("nrsl-clinicName", this.clinicName)
      } else {
        window.sessionStorage.removeItem("nrsl-clinicName")
      }
      if (this.doctorName !== "" && !!this.doctorName) {
        window.sessionStorage.setItem("nrsl-doctorName", this.doctorName)
      } else {
        window.sessionStorage.removeItem("nrsl-doctorName")
      }
      window.sessionStorage.setItem("nrsl-year", this.year);
      window.sessionStorage.setItem("nrsl-month", this.month);
      this.$store.dispatch('NSIPS_RELATION_SITUATIONS_SEARCH', { url: url, data: data, callback: callback})
    },
    getClinics: function () {
      this.$store.dispatch('NS_CLINICS_SEARCH', {data: { 'shop_id': this.shopId, 'year': this.year, 'month': this.month, 'all_disp_flag': true }})
    },
    clearClinics: function () {
      this.autoCompleteClear({clinic: 500})
    },
    setSearchClinic: function (clinicName) {
      this.clinicName = clinicName
      this.autoCompleteClear({clinic: 0})
    },
    getDoctors: function () {
      this.$store.dispatch('NS_DOCTORS_SEARCH', { data: { 'shop_id': this.shopId, 'year': this.year, 'month': this.month, 'all_disp_flag': true } })
    },
    clearDoctors: function () {
      this.autoCompleteClear({doctor: 500})
    },
    setSearchDoctor: function (doctorName) {
      this.doctorName = doctorName
      this.autoCompleteClear({doctor: 0})
    },
    /** オートコンプリートクリア */
    autoCompleteClear: function (param) {
      var time = Object.assign({}, {doctor: 100, clinic: 100}, param)
      this.$store.dispatch('NS_CLINIC_AUTOCOMPLETE_CLEAR', time.clinic)
      this.$store.dispatch('NS_DOCTOR_AUTOCOMPLETE_CLEAR', time.doctor)
    },
    lazyExec: function (func) {
      this.$nextTick(func)
    },
    selectedPatient: function (patient_code,patient_name) {
      this.$router.push({ path: '/nsips/patients/list', query: { patient_code: patient_code, patient_name: patient_name }})
    },
    selectedClinic: function (clinic_code,clinic_name) {
      this.$router.push({ path: '/nsips/clinics/list', query: { clinic_code: clinic_code, clinic_name: clinic_name }})
    },
    selectedDoctor: function (prescription,doctor_name) {
      this.$router.push({ path: '/nsips/doctors/list', query: { doctor_code: prescription.attributes['doctor-code'], clinical_department_code: prescription.attributes['clinical-department-code'], medical_institution_reception_code: prescription.attributes['medical-institution-reception-code'], doctor_name: doctor_name }})
    },
    /** 解除ボタン押下時 */
    removePatient: function (patient_code) {
      var self = this
      // 確認ダイアログ設定+表示
      this.confirmTitle = this.$t('nsips.patient.modal_title')
      this.confirmMessage = this.$t('nsips.relation_remove.patient')
      this.confirmOnYes = () => {
        self.$store.dispatch('NSIPS_RELATION_SITUATIONS_PATIENT_REMOVE', { data: { 'shop_id': this.shopId ,'patient_code': patient_code }, callback:this.search })
      }
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    },
    removeClinic: function (clinic_code,clinic_id) {
      var self = this
      // 確認ダイアログ設定+表示
      this.confirmTitle = this.$t('nsips.clinic.modal_title')
      this.confirmMessage = this.$t('nsips.relation_remove.clinic')
      this.confirmOnYes = () => {
        self.$store.dispatch('NSIPS_RELATION_SITUATIONS_CLINIC_REMOVE', { data: { 'medical_institution_reception_code':clinic_code, 'clinic_id': clinic_id }, callback:this.search })
      }
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    },
    removeDoctor: function (clinic,doctor_code,doctor_id) {
      var self = this
      // 確認ダイアログ設定+表示
      this.confirmTitle = this.$t('nsips.doctor.modal_title')
      this.confirmMessage = this.$t('nsips.relation_remove.doctor')
      this.confirmOnYes = () => {
        self.$store.dispatch('NSIPS_RELATION_SITUATIONS_DOCTOR_REMOVE', { data: { 'medical_institution_reception_code': clinic, 'doctor_code':doctor_code, 'doctor_id':doctor_id }, callback:this.search })
      }
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/nsips-relation-situations-list.js